import gql from 'graphql-tag';

import { fileQueryFields } from './common.queries';
import { buildPaginationQueryParams } from './utils';

export const getConversationsForFinancing = gql`
query financingAgFinancingConversations($agFinancingId: ID!, $conversationId: String) {
  financingAgFinancingConversations(agFinancingId: $agFinancingId, conversationId: $conversationId) {
    id
    archived
    createdAt
    roles
    subject
    createdBy {
      id
      firstName
      lastName
      role {
        id
        name
      }
    }
    previewMessage {
      id
      body
      attachments {
        ${fileQueryFields}
      }
    }
  }
}
`;

const conversationInfo = `
id
archived
createdAt
roles
subject
agFinancing {
  id
  creditAnalystAssigned {
    id
    firstName
    lastName  
  } 
  grower {
    id
    name
    state {
      id
      name
    }
  }
  phase2 {
    id
    collateral {
      id
      status 
    }
    credit {
      id
      status
    }
    fieldMonitoring {
      id 
      startedAt
      completedAt
    }
  }
  orderInfo {
    opportunities {
      id
      collateralGroup
      contractValue
    }
  }
}
createdBy {
  id
  firstName
  lastName
  role {
    id
    name
  }
}
previewMessage {
  id
  body
  sentAt
  sentBy {
    id
    firstName
    lastName
    role {
      id
    }
  }
  sentAt
  attachments {
    ${fileQueryFields}
  }
}
`;
export const getConversationsForNotifications = gql`
query($pagination: AGFPagination, $filters: AGFNotificationCustomFilters) {
  financingAgFinancingConversationNotifications(pagination: $pagination, filters: $filters) {
    ${buildPaginationQueryParams(conversationInfo)}
  }
}
`;

export const getConversationsMessagesForFinancing = gql`
query financingAgFinancingConversations($agFinancingId: ID!, $conversationId: String) {
  financingAgFinancingConversations(agFinancingId: $agFinancingId, conversationId: $conversationId) {
    id
    messages {
      id
      body
      sentBy {
        id
        firstName
        lastName
        role {
          id
          name
        }
      }
      sentAt
      attachments {
        ${fileQueryFields}
      }
    }
  }
}
`;

export const archiveConversation = gql`
  mutation changeArchiveStatusForConversation($conversationId: String!, $archived: Boolean!) {
    changeArchiveStatusForConversation(conversationId: $conversationId, archived: $archived) {
      id
      archived
    }
  }
`;

export const createAgConversation = gql`
  mutation createAgConversation($agFinancingId: ID!, $roles: [String]!, $message: AgMessageInput, $subject: String) {
    createAgConversation(agFinancingId: $agFinancingId, roles: $roles, message: $message, subject: $subject) {
      id
      roles
      subject
    }
  }
`;

export const sendAgMessage = gql`
  mutation sendAgMessage($conversationId: String!, $message: AgMessageInput!) {
    sendAgMessage(conversationId: $conversationId, message: $message) {
      id
    }
  }
`;
